/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Amenity
 */
export interface Amenity {
    /**
     * Amenity code
     * @type {string}
     * @memberof Amenity
     */
    code?: string;
    /**
     * Amenity name
     * @type {string}
     * @memberof Amenity
     */
    name?: string;
    /**
     * Amenity description
     * @type {string}
     * @memberof Amenity
     */
    description?: string;
}

/**
 * Check if a given object implements the Amenity interface.
 */
export function instanceOfAmenity(value: object): value is Amenity {
    return true;
}

export function AmenityFromJSON(json: any): Amenity {
    return AmenityFromJSONTyped(json, false);
}

export function AmenityFromJSONTyped(json: any, ignoreDiscriminator: boolean): Amenity {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function AmenityToJSON(json: any): Amenity {
    return AmenityToJSONTyped(json, false);
}

export function AmenityToJSONTyped(value?: Amenity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'description': value['description'],
    };
}

